import { render, staticRenderFns } from "./kullanici_ekle.vue?vue&type=template&id=5919ffee&scoped=true&"
import script from "./kullanici_ekle.vue?vue&type=script&lang=js&"
export * from "./kullanici_ekle.vue?vue&type=script&lang=js&"
import style0 from "./kullanici_ekle.vue?vue&type=style&index=0&id=5919ffee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5919ffee",
  null
  
)

export default component.exports